import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 bg-brand-cream text-brand-darkText" data-id="element-209">
      <div className="max-w-4xl mx-auto" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-211">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-brand-dark mb-6" data-id="element-212">
            El Precio — Y Por Qué Tiene Sentido
          </h2>
          <p className="text-lg text-brand-dark/80 max-w-2xl mx-auto" data-id="element-213">
            Piensa en cuánto gastas cada semana en snacks que no funcionan. La
            bolsa de chips: $4. El chocolate: $3. El café dulce: $6. El snack
            "saludable": $8.
          </p>
          <p className="text-xl font-bold text-brand-medium mt-4" data-id="element-214">
            Eso es más de $20 por semana — $80 al mes — en snacks que no apagan
            el antojo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl border-2 border-brand-gold p-8 md:p-12 text-center relative overflow-hidden" data-id="element-215">
          <div className="absolute top-0 left-0 w-full h-2 bg-gold-gradient" data-id="element-216" />

          <h3 className="text-sm font-bold tracking-widest text-brand-medium uppercase mb-8" data-id="element-217">
            Inversión Única • Precio de Lanzamiento
          </h3>

          <div className="flex items-center justify-center gap-6 mb-8" data-id="element-218">
            <span className="text-4xl md:text-5xl text-brand-dark/30 line-through font-heading" data-id="element-219">
              $47
            </span>
            <span className="text-7xl md:text-8xl font-bold text-brand-dark font-heading" data-id="element-220">
              $6.36
            </span>
          </div>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-brand-dark/70 font-medium mb-10" data-id="element-221">
            <span data-id="element-222">✓ Acceso inmediato</span>
            <span className="hidden md:block text-brand-gold" data-id="element-223">•</span>
            <span data-id="element-224">✓ Descarga digital</span>
            <span className="hidden md:block text-brand-gold" data-id="element-225">•</span>
            <span data-id="element-226">✓ Tuyo para siempre</span>
          </div>

          <CTAButton pulsing className="w-full md:w-auto px-12 py-5 text-xl" data-id="element-227">
            DESCARGAR MIS 25 RECETAS AHORA
          </CTAButton>

          <p className="mt-6 text-sm text-brand-dark/60" data-id="element-228">
            $6.36 es menos de lo que gastas en 2 días de snacks procesados. Y
            este sistema dura toda la vida.
          </p>
        </motion.div>
      </div>
    </section>;
}